<div class="child-info">

  @if (!ready) {
    <div>
      <se-fe-spinner
        seFeDataSize="950"
        [seFeDataInverted]="false"
        [seFeDataCenter]="true"
      ></se-fe-spinner>
    </div>
  }

  @if (ready) {
    <div role="content" class="child-info-content">
      <se-po-add-child-profile #childInfo [optionalFields]="optionalFields"></se-po-add-child-profile>
      <div class="form-submit">
        <se-fe-button
          seFeDataEmphasis="high"
          seFeDataType="button"
          (click)="submit()"
          [seFeDataFullWidth]="true"
        >Add Child Profile</se-fe-button>
      </div>
    </div>
  }
</div>
